import React, {useEffect} from "react";
import Loader from "../../components/loader";
import {useLocation, useNavigate} from "react-router-dom";


export default function ManagerWrapper() {
    const location = useLocation();
    return <Manager key={location.key} />
}

function Manager() {
    const navigate = useNavigate();
    function sendMessageToSDK(type, data = null, status = null, step = null) {
        const message = {
            type: type,
            data: data,
            status: status,
            step: step,
            timestamp: Date.now()
        };

        window.parent.postMessage(message, '*');
    }
    useEffect(() => {
        const handleMessage = (event) => {
            const { type, data } = event.data;

            console.log('data.path', data.path);
            switch (type) {
                case 'initialize':
                    sendMessageToSDK('ready');
                    break;

                case 'startLiveness':
                    navigate(`${data.path}&isManager=true`)
                    // this.startLivenessProcess(data);
                    break;

                case 'startCardCapture':
                    navigate(`${data.path}&isManager=true`)
                    break;
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div>
            <Loader color="#FFF" primary="#FF3D00" />
        </div>
    )
}
